import { GTMEventData } from '@/constants/GTMEventData';

/**
 * GTM Manager utility - Handles Google Tag Manager initialization and updates
 */

/**
 * Initialize or reinitialize Google Tag Manager with the specified ID
 * @param {string} gtmId - The Google Tag Manager ID to use
 */
export const initializeGTMForHead = (gtmId) => {
  if (typeof window === 'undefined' || !gtmId) {
    return;
  }

  try {
    // Clear existing dataLayer to prevent conflicts
    window.dataLayer = window.dataLayer || [];

    // Remove any existing GTM script tags to avoid duplicate initializations
    const existingScripts = document.querySelectorAll(
      'script[src*="googletagmanager.com/gtm.js"]',
    );
    existingScripts.forEach((script) => {
      script.remove();
    });

    // Create a new script element for GTM
    const scriptElement = document.createElement('script');
    scriptElement.defer = true;
    scriptElement.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;

    // Add the script to the head
    document.head.appendChild(scriptElement);
  } catch (error) {
    // Log errors silently
    // eslint-disable-next-line no-console
    console.error('Error initializing GTM:', error);
  }
};

/**
 * Update the GTM noscript iframe with a new GTM ID
 * @param {string} gtmId - The Google Tag Manager ID to use
 */
export const initializeGTMForBody = (gtmId) => {
  if (typeof window === 'undefined' || !gtmId) {
    return;
  }

  try {
    // Remove existing noscript iframe
    const existingIframe = document.querySelector(
      'iframe[src*="googletagmanager.com/ns.html"]',
    );
    if (existingIframe && existingIframe.parentNode) {
      existingIframe.parentNode.removeChild(existingIframe);
    }

    // Create new iframe
    const noScriptContainer = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    noScriptContainer.appendChild(iframe);
    document.body.insertBefore(noScriptContainer, document.body.firstChild);
  } catch (error) {
    // Log errors silently
    // eslint-disable-next-line no-console
    console.error('Error updating GTM noscript:', error);
  }
};

export const triggerCustomGTMEvent = (type, customData = {}) => {
  if (GTMEventData[type]) {
    const data = GTMEventData[type];
    window?.dataLayer?.push({
      ...data,
      ...customData,
    });
  }
};
